import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Tablet: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '16', height: '20', x: '4', y: '2', rx: '2', ry: '2' }],
    ['line', { x1: '12', x2: '12.01', y1: '18', y2: '18' }],
  ],
];

export default Tablet;
